import { PAYMENT_ACTIONS } from '@constants/paymentActions'
import { ConfirmPaymentParams, AdyenPaymentResponse } from '@hooks/useBookingFlow'

export const checkIs3DSResponse = (params: ConfirmPaymentParams): params is AdyenPaymentResponse => {
  return params.action === PAYMENT_ACTIONS.THREE_D_SECURE && params.details?.action && 'type' in params.details.action
}
